/**
 * API Constants - Shared constants for the control-plane API client
 */

export const API_BASE = (import.meta.env.VITE_API_URL || '/v1') + '/internal';

// LocalStorage keys for platform-admin token management
// (distinct from apps/web's keys - a different identity, never meant to mix)
export const ACCESS_TOKEN_KEY = 'resolveai-control-plane-access-token';
export const REFRESH_TOKEN_KEY = 'resolveai-control-plane-refresh-token';
